import { useState, useEffect, useCallback } from "react";

export function useCooldown(seconds = 60) {
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldown]);

  const start = useCallback(() => setCooldown(seconds), [seconds]);

  return { cooldown, start, isActive: cooldown > 0 };
}
